// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedRestRouteImport } from './routes/_protected/_rest'
import { Route as ProtectedEditorWorkflowsWorkflowIdRouteImport } from './routes/_protected/_editor/workflows/$workflowId'
import { Route as ProtectedRestWorkflowsIndexRouteImport } from './routes/_protected/_rest/workflows/index'
import { Route as ProtectedRestExecutionsIndexRouteImport } from './routes/_protected/_rest/executions/index'
import { Route as ProtectedRestCredentialsIndexRouteImport } from './routes/_protected/_rest/credentials/index'
import { Route as ProtectedRestExecutionsExecutionIdRouteImport } from './routes/_protected/_rest/executions/$executionId'
import { Route as ProtectedRestCredentialsNewRouteImport } from './routes/_protected/_rest/credentials/new'
import { Route as ProtectedRestCredentialsCredentialIdRouteImport } from './routes/_protected/_rest/credentials/$credentialId'

const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/_auth/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/_auth/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedRoute
          })
const ProtectedRestRoute = ProtectedRestRouteImport.update({
            id: '/_rest',getParentRoute: () => ProtectedRoute
          })
const ProtectedEditorWorkflowsWorkflowIdRoute = ProtectedEditorWorkflowsWorkflowIdRouteImport.update({
            id: '/_editor/workflows/$workflowId',path: '/workflows/$workflowId',getParentRoute: () => ProtectedRoute
          })
const ProtectedRestWorkflowsIndexRoute = ProtectedRestWorkflowsIndexRouteImport.update({
            id: '/workflows/',path: '/workflows/',getParentRoute: () => ProtectedRestRoute
          })
const ProtectedRestExecutionsIndexRoute = ProtectedRestExecutionsIndexRouteImport.update({
            id: '/executions/',path: '/executions/',getParentRoute: () => ProtectedRestRoute
          })
const ProtectedRestCredentialsIndexRoute = ProtectedRestCredentialsIndexRouteImport.update({
            id: '/credentials/',path: '/credentials/',getParentRoute: () => ProtectedRestRoute
          })
const ProtectedRestExecutionsExecutionIdRoute = ProtectedRestExecutionsExecutionIdRouteImport.update({
            id: '/executions/$executionId',path: '/executions/$executionId',getParentRoute: () => ProtectedRestRoute
          })
const ProtectedRestCredentialsNewRoute = ProtectedRestCredentialsNewRouteImport.update({
            id: '/credentials/new',path: '/credentials/new',getParentRoute: () => ProtectedRestRoute
          })
const ProtectedRestCredentialsCredentialIdRoute = ProtectedRestCredentialsCredentialIdRouteImport.update({
            id: '/credentials/$credentialId',path: '/credentials/$credentialId',getParentRoute: () => ProtectedRestRoute
          })





const ProtectedRestRouteChildren = {
  ProtectedRestCredentialsCredentialIdRoute: ProtectedRestCredentialsCredentialIdRoute,ProtectedRestCredentialsNewRoute: ProtectedRestCredentialsNewRoute,ProtectedRestExecutionsExecutionIdRoute: ProtectedRestExecutionsExecutionIdRoute,ProtectedRestCredentialsIndexRoute: ProtectedRestCredentialsIndexRoute,ProtectedRestExecutionsIndexRoute: ProtectedRestExecutionsIndexRoute,ProtectedRestWorkflowsIndexRoute: ProtectedRestWorkflowsIndexRoute
}

const ProtectedRestRouteWithChildren = ProtectedRestRoute._addFileChildren(ProtectedRestRouteChildren)



const ProtectedRouteChildren = {
  ProtectedRestRoute: ProtectedRestRouteWithChildren,ProtectedIndexRoute: ProtectedIndexRoute,ProtectedEditorWorkflowsWorkflowIdRoute: ProtectedEditorWorkflowsWorkflowIdRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)

const rootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,AuthLoginRoute: AuthLoginRoute,AuthSignupRoute: AuthSignupRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)